module.exports = __webpack_public_path__ + "img/outfield-picnic-pavilion-03.01797bef.jpeg";